import * as React from "react";
import { useState } from "react";
import { Button } from "../../../../../../../react-core/Html/Button";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionEstimatedPayResult } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayResult";
import { PensionEstimatedPayQuery } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayQuery";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { EstimatedPayeMessage } from "../../../Common/Resource/Contents";
import { EstimatedPayeAction } from "../../Actions/EstimatedPayeAction";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import AriaTooltip from "../../../../../../Shared/Tooltip/AriaTooltip";
import { PensionEstimatedPay } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPay";

interface ICalculateEstimatedPaye {
    query: Array<PensionEstimatedPayQuery>;
}

export const CalculateEstimatedPaye = ({ query }: ICalculateEstimatedPaye) => {
    const [displayEstimatedPanel, setDisplayEstimatedPanel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [estimatedPays, setEstimatedPays] = useState<Array<PensionEstimatedPay>>([]);
    const [message, setMessage] = useState(null);

    const getPayeEstimate = function(){
        setIsLoading(true);
        EstimatedPayeAction.calculateEstimatedPayes(query, (result) => {
            if(result?.success){
                setEstimatedPays(result?.data);
            }
            else{
                setMessage(EstimatedPayeMessage.error);
            }
            setDisplayEstimatedPanel(result?.success);
            setIsLoading(false);
        })
    }

    return (
        <>
            <PartLoading isLoading={isLoading}>
                <div className="row">
                    <div className="col-sm-4 col-12 pb-20">
                        <Button className="btn secondary" onClick={() => getPayeEstimate()}>Calculate estimated PAYE</Button>
                    </div>
                </div>
                {message &&
                    <div className="mb-20">
                        <Alert alertType={AlertType.Warning} message={message} hideCloseButton={true}/>
                    </div>
                }
                {displayEstimatedPanel && 
                    estimatedPays.map((estimatedPay,index) => 
                    (
                        <div>
                        {index > 0 && <hr />}
                        {estimatedPay.PensionArrangementId > 0 && <h3>ArrangementRef: {estimatedPay.PensionArrangementId}</h3>}
                        {!estimatedPay.IsSuccess &&
                            <Alert
                                alertType={AlertType.Error}
                                message={EstimatedPayeMessage.error}
                                hideCloseButton={true}
                            />
                        }
                        {estimatedPay.PensionEstimatedPayResults.map(estimatedResult=>
                            (
                                <div className="recap-dl">
                                    <div className="mb-20">
                                    <Alert
                                        alertType={AlertType.Warning}
                                        message= { EstimatedPayeMessage.message }
                                        hideCloseButton={true}
                                    />
                                    </div>
                                    <dl className="def-list narrow">
                                    {estimatedPay.PensionEstimatedPayResults.length > 1 &&
                                        (<div>
                                            <dt>WorkReference</dt>
                                            <dd>
                                                <span>{estimatedResult?.WorkReference}</span>
                                            </dd>
                                        </div>)
                                    }
                                        <dt>Estimated PAYE tax</dt>
                                        <dd>
                                            <div>
                                                <span data-test="estimatedPayeTax">{MoneyDisplayHelper.FromatMoneyDisplay(
                                                    estimatedResult?.EstimatedPayTax?.Amount,
                                                    estimatedResult?.EstimatedPayTax?.Currency || CurrencyCode.GBP
                                                )}</span>                                               
                                            </div>
                                        </dd>
                                        <dt>Estimated net payment</dt>
                                        <dd>
                                            <span>{MoneyDisplayHelper.FromatMoneyDisplay(
                                                estimatedResult?.EstimatedNetPayment?.Amount,
                                                estimatedResult?.EstimatedNetPayment?.Currency || CurrencyCode.GBP
                                            )}</span>
                                        </dd>
                                        <dt>Tax Code</dt>
                                        <dd>{estimatedResult?.TaxCode}</dd>
                                        <dt>Basis</dt>
                                        <dd>{estimatedResult?.TaxBasis}</dd>
                                    </dl>
                                </div>
                            ))
                        }
                        
                        </div>
                            
                    ))
                }
            </PartLoading>
        </>
    );
};

